import { useFetchData } from 'hooks/apiHooks';
import React, { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import ApiError from './ApiError';
import { useTranslation } from 'react-i18next';
import SpreadsheetPreview from '../spreadsheet/SpreadsheetPreview';
import { API_ENDPOINTS } from 'constants';

const MediaViewer = ({ uploadId, unique_filename, maxHeight, alt, style={} }) => {
    const { t } = useTranslation(); 
    const [mediaData, setMediaData] = useState(null);
    const [mediaUrl, setMediaUrl] = useState(null);
    const route = uploadId ? API_ENDPOINTS.UPLOADS.DOWNLOAD(uploadId) : API_ENDPOINTS.UPLOADS.FILE(unique_filename)
    const { fetchBlob, mediaType, isLoading, error } = useFetchData(route, null, false);

    useEffect(() => {
        if(uploadId || unique_filename){
            fetchBlob().then((pdfBlob) => {
                if (pdfBlob) {
                    setMediaData(pdfBlob)
                    setMediaUrl(URL.createObjectURL(pdfBlob));
                }
            });
        }
    }, [fetchBlob, uploadId, unique_filename]);

    if(maxHeight){
        style = { maxHeight, width: 'auto' }
    }

    if (isLoading) return <Skeleton height={maxHeight || 460} count={1} />;
    if (error) return <ApiError retryFetch={fetchBlob} errorMessage={error.message} />;

    if (mediaType.startsWith('video')) {
        return(
            <video width="100%" height={maxHeight} className="max-media-width" controls={true} playsInline muted>
                <source src={mediaUrl} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        );
    } else if (mediaType.startsWith('text/csv') || mediaType.startsWith('application/vnd.openxmlformats')) {
        return(
            <div style={{ width: '100%', height: '50vh', overflowY: 'auto' }}>
                <SpreadsheetPreview src={mediaData}/>
            </div>
        );
    } else if (mediaType === 'application/pdf') {
        return (
            <div style={{ width: '100%', height: '50vh' }}>
                <iframe
                    src={mediaUrl}
                    style={{ width: '100%', height: '100%', border: 'none' }}
                    title="PDF Viewer"
                />
            </div>
        );
    } else if (mediaType.startsWith('image/')) {
        return <img src={mediaUrl} alt={alt || t('uploads.label.defaultAlt')} style={style} />;
    } else {
        return <p>{t('error.unsupportedMedia')}</p>;
    }
};

export default MediaViewer;